/* Video de la ficha de preventa: la miniatura "Video" cambia la foto grande por el reproductor,
   y cualquier miniatura de foto lo vuelve a esconder (y lo pausa). Sin carrusel. Sin autoplay:
   el video arranca solo cuando la persona toca la miniatura. */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-pv-galeria]'), function (g) {
    var panel = g.querySelector('[data-pv-video]');
    var mini = g.querySelector('[data-pv-video-mini]');
    var foto = g.querySelector('.pv-foto');
    if (!panel || !mini || !foto) return;
    var video = panel.querySelector('video');
    var fotos = g.querySelectorAll('.pv-mini');

    function mostrarVideo() {
      foto.hidden = true;
      panel.hidden = false;
      Array.prototype.forEach.call(fotos, function (o) { o.removeAttribute('aria-current'); });
      mini.setAttribute('aria-current', 'true');
      try { var p = video.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
    }
    function mostrarFoto() {
      if (panel.hidden) return;
      try { video.pause(); } catch (e) {}
      panel.hidden = true;
      foto.hidden = false;
      mini.removeAttribute('aria-current');
    }
    mini.addEventListener('click', mostrarVideo);
    Array.prototype.forEach.call(fotos, function (m) { m.addEventListener('click', mostrarFoto); });
  });
})();
